import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';

export const ProjectsDirectoryManageRedirect = (): React.JSX.Element => (
	<ScreenRedirect to="/jira/settings/projects/manage" />
);
